<template>
  <div
    v-for="log in props.sharepointActivityLogs"
    :key="log.logId"
    class="relative mb-4 last:mb-0 p-5 bg-white border border-gray-100 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200"
  >
    <!-- Header -->
    <div class="flex items-center justify-between mb-3">
      <p class="text-sm text-gray-600 font-medium">
        <span class="text-gray-900 font-semibold">Actor:</span> {{ log.actor }}
      </p>

      <!-- Badge -->
      <span
        class="text-xs px-2 py-1 rounded-full font-medium capitalize"
        :class="actionBadgeClass(log)"
      >
        {{ getActionType(log.action) }}
      </span>
    </div>

    <!-- ====================== -->
    <!-- RENAME ACTIVITY VIEW   -->
    <!-- ====================== -->
    <template v-if="getActionType(log.action) === 'rename'">
      <div class="text-sm text-gray-700 leading-6">
        <p>
          <span class="font-medium text-gray-500">Old Name:</span>
          {{ (log.action as any)?.rename?.oldName }}
        </p>

        <p v-if="(props.sharepointActivityFile as any)?.type == 'file'">
          <span class="font-medium text-gray-500">New Name:</span>
          {{ (props.sharepointActivityFile as any)?.name }}
        </p>

        <p class="mt-1 text-gray-600">
          <span class="font-medium text-gray-500">Date:</span>
          {{ formatDate(log.activityDateTime) }}
        </p>
      </div>
    </template>

    <!-- ====================== -->
    <!-- DELETE ACTIVITY VIEW   -->
    <!-- ====================== -->
    <template v-else-if="getActionType(log.action) === 'delete'">
      <div class="text-sm text-gray-700 leading-6">
        <p>
          <span class="font-medium text-gray-500">Deleted File:</span>
          {{ (log.action as any)?.delete?.name || 'File removed' }}
        </p>

        <p class="mt-1 text-gray-600">
          <span class="font-medium text-gray-500">Date:</span>
          {{ formatDate(log.activityDateTime) }}
        </p>
      </div>
    </template>

    <!-- ====================== -->
    <!-- EDIT ACTIVITY VIEW     -->
    <!-- ====================== -->
    <template v-else-if="getActionType(log.action) === 'edit'">
      <div class="text-sm text-gray-700 leading-6">
        <p>
          <span class="font-medium text-gray-500">Edited File: </span>
          <template v-if="(props.sharepointActivityFile as any)?.type == 'file'">
            {{ (props.sharepointActivityFile as any)?.name }}
          </template>
        </p>

        <p class="mt-1 text-gray-600">
          <span class="font-medium text-gray-500">Date:</span>
          {{ formatDate(log.activityDateTime) }}
        </p>
      </div>
    </template>

    <!-- ====================== -->
    <!-- MOVE FROM ACTIVITY VIEW           -->
    <!-- ====================== -->
    <template v-else-if="getActionType(log.action) === 'moved from'">
      <div class="text-sm text-gray-700 leading-6">
        <p>
          <span class="font-medium text-gray-500">Moved From File:</span>
          {{ getFileName(log.action) }}
        </p>

        <p class="mt-1 text-gray-600">
          <span class="font-medium text-gray-500">Date:</span>
          {{ formatDate(log.activityDateTime) }}
        </p>
      </div>
    </template>

    <!-- ====================== -->
    <!-- MOVE TO ACTIVITY VIEW           -->
    <!-- ====================== -->
    <template v-else-if="getActionType(log.action) === 'moved to'">
      <div class="text-sm text-gray-700 leading-6">
        <p>
          <span class="font-medium text-gray-500">Moved To File:</span>
          {{ getFileName(log.action) }}
        </p>

        <p class="mt-1 text-gray-600">
          <span class="font-medium text-gray-500">Date:</span>
          {{ formatDate(log.activityDateTime) }}
        </p>
      </div>
    </template>
    <!-- ====================== -->
    <!-- DEFAULT VIEW           -->
    <!-- ====================== -->
    <template v-else>
      <div class="text-sm text-gray-700 leading-6">
        <p>
          <span class="font-medium text-gray-500">File:</span>
          {{ getFileName(log.action) }}
        </p>

        <p class="mt-1 text-gray-600">
          <span class="font-medium text-gray-500">Date:</span>
          {{ formatDate(log.activityDateTime) }}
        </p>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { SharepointActivityLog } from '@/models/SharepointActivityLog';

interface Props {
  sharepointActivityLogs: SharepointActivityLog[];
  sharepointActivityFile: null;
}
const props = defineProps<Props>();


const getFileName = (action) => {
  const key = Object.keys(action)[0];
  const obj = action[key];
  if (key === "rename" && (props.sharepointActivityFile as any)?.type === "file") {
    return obj.oldName + " is renamed to " + (props.sharepointActivityFile as any)?.name;
  }
  if(key === "move"){
    return obj.from || obj.to;
  }
  return obj.oldName || obj.name || "N/A";
};

const formatDate = (date) => {
  return new Date(date).toLocaleString();
}

const getActionType = (action) =>{
  // returns the key (rename, delete, etc.)
  if (Object.keys(action)[0] =="move") {
    if(action.move.from){
      return "moved from";
    }
    else if(action.move.to){
      return "moved to";
    }
  }

  return Object.keys(action)[0];
}

const actionBadgeClass = (log) => {
  const t = getActionType(log.action)?.replace(" ", "_");
  console.log(t);
  return {
    delete: "bg-red-100 text-red-700",
    rename: "bg-blue-100 text-blue-700",
    edit: "bg-green-100 text-green-700",
    move: "bg-green-100 text-green-700",
    moved_to: "bg-green-100 text-green-700",
    moved_from: "bg-green-100 text-green-700",
  }[t] || "bg-gray-100 text-gray-600";
};
</script>
